import { ScreenType } from '@tmdb-graphql-api/schema/types';
import { type MovieFormikValues, type TvFormikValues } from '../types.ts';

export const areMovieFormikValues = (
  _values: MovieFormikValues | TvFormikValues,
  type: ScreenType,
): _values is MovieFormikValues => type === ScreenType.Movie;
